import React from 'react';
import { DOCUMENTATION } from '../constants/docLinks';

// Builds antd Menu `items` for a documentation type, for use in a Dropdown or submenu (e.g. DocumentationLinksDropdown, TopBar "More" menu).
export const buildDocumentationMenuItems = (documentationType) => {
    const { links, labels } = DOCUMENTATION[documentationType] || {};
    return Object.entries(links).map(([key, url]) => ({
        key: key.toLowerCase(),
        label: (
            <a href={url} target="_blank" rel="noopener noreferrer">
                {labels[key] || key}
            </a>
        ),
    }));
};
